import React, { ReactNode } from 'react';

import clsx from 'clsx';

import styles from './TableHead.module.scss';

interface TableHeadProps {
  children: ReactNode;
  className?: string;
}

const TableHead = ({ children, className }: TableHeadProps) => {
  return <div className={clsx(styles.tableHead, className)}>{children}</div>;
};

export default TableHead;
